import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const navLinks = [{
  label: 'Home',
  href: '#home'
}, {
  label: 'About',
  href: '#about'
}, {
  label: 'Services',
  href: '#services'
}, {
  label: 'Noir Atelier',
  href: '#noir-atelier'
}, {
  label: 'Contact',
  href: '#contact'
}];
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled ? 'bg-dark-900/95 backdrop-blur-md shadow-lg' : 'bg-transparent'}`} data-id="element-89">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-90">
        <div className="flex items-center justify-between h-20" data-id="element-91">
          <a href="#home" className="flex items-center gap-3" data-id="element-92">
            <span className="text-gold font-display text-xl font-bold tracking-widest" data-id="element-93">
              VANSCAPE
            </span>
          </a>

          <div className="hidden md:flex items-center gap-8" data-id="element-94">
            {navLinks.map(link => <a key={link.label} href={link.href} className="text-sm font-medium text-white/70 hover:text-gold transition-colors duration-300 tracking-wide uppercase" data-id="element-95">
                {link.label}
              </a>)}
          </div>

          <div className="hidden md:block" data-id="element-96">
            <a href="#contact" className="inline-block px-6 py-2.5 bg-gold text-dark-900 text-sm font-semibold tracking-wide uppercase rounded hover:bg-gold-hover transition-colors duration-300" data-id="element-97">
              Get a Quote
            </a>
          </div>

          <button className="md:hidden text-white/80 hover:text-gold transition-colors" onClick={() => setMobileOpen(!mobileOpen)} aria-label="Toggle menu" data-id="element-98">
            {mobileOpen ? <XIcon size={24} data-id="element-99" /> : <MenuIcon size={24} data-id="element-100" />}
          </button>
        </div>
      </div>

      <AnimatePresence data-id="element-101">
        {mobileOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-dark-900/98 backdrop-blur-md border-t border-white/5" data-id="element-102">
            <div className="px-6 py-6 space-y-4" data-id="element-103">
              {navLinks.map(link => <a key={link.label} href={link.href} onClick={() => setMobileOpen(false)} className="block text-sm font-medium text-white/70 hover:text-gold transition-colors tracking-wide uppercase" data-id="element-104">
                  {link.label}
                </a>)}
              <a href="#contact" onClick={() => setMobileOpen(false)} className="inline-block mt-4 px-6 py-2.5 bg-gold text-dark-900 text-sm font-semibold tracking-wide uppercase rounded" data-id="element-105">
                Get a Quote
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}